import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";

import {
  UserActionTypeEnum,
  userIsLoggedIn,
  useUserDispatch,
} from "../../context/UserContext";
import { SignInScreen } from "../signin/SignInScreen";
import UserService from "../../services/UserService";
import {Launcher} from "../../InitApp";

export const SignOutScreen = (props: any) => {
  // Context
  const dispatch = useUserDispatch();
  // State
  const [loading, setLoading] = useState(true);
  // Others
  const isLogged = userIsLoggedIn();

  useEffect(() => {
    UserService.logout().then((_) => {
      setLoading(false);
      dispatch({
        type: UserActionTypeEnum.logout,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isLogged) {
    return <Redirect to={{ pathname: SignInScreen.routeName }} />;
  }

  return (
      <Launcher />
  );
};

SignOutScreen.routeName = "/signout";

export default SignOutScreen;
